import Button from "@/common/components/Button"
import Modal from "@/common/components/Modal"
import useCreateCompanyUserCard from "@/features/privateCompanies/hooks/useCreateCompanyUserCard"
import { useQueryClient } from "@tanstack/react-query"

interface CreateCompanyUserCardProps {
  companyUserId?: string
}

export const CreateCompanyUserCard = ({ companyUserId }: CreateCompanyUserCardProps) => {
  const queryClient = useQueryClient()

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['companyUser', companyUserId] })
  }

  const {
    mutate: createCompanyUserCard,
    isPending: createCompanyUserCardIsPending,
  } = useCreateCompanyUserCard({
    companyUserId,
    onSuccess,
  })

  return (
    <Modal
      Trigger={(
        <Button type="button" name="create_card">
          Solicitar cartão personal
        </Button>
      )}
      title="Você tem certeza?"
      subtitle="Ao solicitar o Cartão Personal será enviada uma ordem de emissão para a Tcard"
      showClose={false}
      useCancellableFooter
      confirmButtonText="Solicitar cartão"
      confirmButtonClassName="bg-blue-700"
      disabled={createCompanyUserCardIsPending}
      onConfirm={createCompanyUserCard}
      dataTestid="confirm_create_card"
    />
  )
}
